import React from 'react'
import { Link } from 'gatsby'

import blog from '../assets/nav-blog.png'
import floppy from '../assets/nav-floppy.png'
import readOutLoud from '../assets/nav-read-out-loud.svg'
// import website from '../assets/nav-website.png'
import moon from '../assets/moon.png'
import { slugify } from '../utils/helpers'

const mainNavItems = [
  { url: '/', icon: floppy, label: 'Home' },
  { url: '/blog', icon: blog, label: 'Blog' },
  { url: '/categories/read-out-loud', icon: readOutLoud, label: 'Read Out Loud' },
]

const socialNavItems = [
  // { url: 'https://tegarsantosa.com', icon: website, label: 'Website' },
]

export const Navigation = ({ onUpdateTheme }) => {
  return (
    <section className="navigation">
      <div className="container">
        <nav>
          {mainNavItems.map((item) => (
            <div className="nav-item-outer" key={item.url}>
              <Link
                to={item.url}
                key={item.label}
                activeClassName="active"
                className={`item ${slugify(item.label)} ${
                  item.mobileOnly ? 'mobile-only' : ''
                }`}
              >
                <img src={item.icon} alt={item.label} className="nav-image" />
                <span>{item.label}</span>
              </Link>
            </div>
          ))}

          {socialNavItems.map((item) => (
            <div className="nav-item-outer" key={item.url}>
              <a
                href={item.url}
                key={item.label}
                className={`desktop-only item ${slugify(item.label)}`}
                target="_blank"
                rel="noreferrer"
              >
                <img src={item.icon} alt={item.label} className="nav-image" />
                <span>{item.label}</span>
              </a>
            </div>
          ))}
        </nav>
        <div className="theme-toggle">
          <button onClick={onUpdateTheme}>
            <img src={moon} alt="Theme" />
          </button>
        </div>
      </div>
    </section>
  )
}
